export default __webpack_public_path__ + "static/media/warning-icon.f7a42bc5.svg";